var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeatable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.759 8.421a6.964 6.964 0 1 0 .488 6.327l1.879.786a9 9 0 1 1-.652-8.211l.811-2.83 1.72.494-1.726 6.018-6.018-1.726.493-1.72 3.005.862z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatable);
export default __webpack_public_path__ + "static/media/repeatable.e9becff5fd94f135fc3634d3f77bf033.svg";
export { ForwardRef as ReactComponent };